import * as actions from 'redux/actions/serpChecker.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'

const initialState = {
  keyword: '',
  serpResults: null,
  loading: false,
  previousResults: []
}

const serpCheckerReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getSerpCheckerResults.type:
      return {
        ...state,
        loading: true,
        serpResults: null
      }

    case actions.loadSerpCheckerPreviousSuccess.type:
      return {
        ...state,
        keyword: payload.data.attributes.word,
        serpResults: payload.data,
        loading: false
      }

    case actions.setKeyword.type: 
      return {
        ...state,
        keyword: payload.keyword
      }

    case actions.getSerpCheckerResultsSuccess.type:
      return {
        ...state,
        serpResults: payload.data,
        loading: false
      }

    case actions.getSerpCheckerResultsFailure.type:
      return {
        ...state,
        loading: false
      }

    case actions.getSerpCheckerHistorySuccess.type:
      return {
        ...state,
        previousResults: payload.data?.length
          ? payload.data.sort((a, b) => (a.attributes.createdAt > b.attributes.createdAt ? -1 : 1))
          : []
      }

    case actions.getSerpCheckerResultsNotReady.type:
      return {
        ...state,
        serpResults: payload.data
      }

    case actions.resetResults.type:
      return {
        ...state,
        serpResults: null
      }

    case actions.deleteKeywords.type: {
      return {
        ...state,
        previousResults: state.previousResults.filter(
          history => payload.historyId !== history.attributes.id
        )
      }
    }

    case 'ROUTE_CHANGE':
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return {
        ...initialState,
        previousResults: [...state.previousResults]
      }
    default:
      return state
  }
}

export default serpCheckerReducer
